import { LiteralUnion, Message, RegisterOptions } from 'react-hook-form'
import { Dispatch } from 'redux'

import { dispatchCreateNotification, isErrorResponse } from 'src/action-creators'

type ErrorOption = {
  message?: Message
  type?: LiteralUnion<keyof RegisterOptions, string>
  shouldFocus?: boolean
}

interface HandleErrorResponseDeps<FormValue extends {}> {
  dispatch: Dispatch
  setError?: (key: keyof FormValue, options: ErrorOption) => void
  formValue?: FormValue
}

export const handleErrorResponse =
  <Fields extends {}>({ setError, dispatch, formValue }: HandleErrorResponseDeps<Fields>) =>
  (error: unknown) => {
    if (error instanceof Error) {
      dispatchCreateNotification(dispatch)({
        type: 'negative',
        message: error.message,
      })
    }

    if (isErrorResponse(error)) {
      const { validationErrors, userMessage } = error

      const isFieldInForm = (field: string | number | symbol): field is keyof Fields =>
        !!formValue && field in formValue

      if (validationErrors) {
        Object.keys(validationErrors).forEach(field => {
          if (isFieldInForm(field) && Array.isArray(validationErrors[field])) {
            setError?.(field, { message: validationErrors[field]?.[0] })
          }
        })
      }

      dispatchCreateNotification(dispatch)({
        type: 'negative',
        message: validationErrors?.nonFieldErrors?.[0] || userMessage,
      })
    }
  }
